<ng-container *transloco="let t;">
<!-- Invite to read Modal -->
<div>
    <div class="modal-header">
        <h4 class="modal-title">{{t("More tab invite to read text (More tab) - Invite to read")}}</h4>
        <button type="button" class="close" (click)="activeModal.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="inviteToRead" (ngSubmit)="onSubmit()">
    <div class="modal-body" tabindex="0" ngbAutofocus>
            <div class="intiveToView-fields-container">
                <div class="row">
                    <div formGroupName="recipient">
                        <div class="row">
                            <div class="col-xl-6 col-md-6 col-6 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="firstname" >{{t("First name (general) - First name")}}</label>
                                    <input type="text" class="form-control" id="firstname" formControlName="firstname" [ngClass]="{'is-invalid error': (submitted && inviteToRead.get('recipient.firstname')?.errors)}" />
                                </div>
                            </div>
                            <div class="col-xl-6 col-md-6 col-6 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="lastname" >{{t("Last name (general) - Last name")}}</label>
                                    <input type="text" class="form-control" id="lastname" formControlName="lastname" [ngClass]="{'is-invalid error': (submitted && inviteToRead.get('recipient.lastname')?.errors)}" />
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12 col-12 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="email">{{t("Email (general) - Email")}}</label>
                                    <input type="email" class="form-control" id="email"  formControlName="email" [ngClass]="{'is-invalid error': (submitted && inviteToRead.get('recipient.email')?.errors)}"/>
                                </div>
                            </div>
                            <div class="col-xl-12 col-md-12 col-12 mb-25">
                                <div class="form-group intiveToView-fields">
                                    <label for="phone_no">{{t("Phone (general) - Phone")}}</label>
                                    <app-phone-input [formControl]="inviteToRead.get('recipient.phone_no')" [isFormSubmitted]="submitted"></app-phone-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-12 col-md-12 col-12 mb-25">
                        <label class="col-form-label pt-0" for="message">{{t("Invitation message field label text (General) - Message")}}</label>
                        <div class="form-group intiveToView-fields">
                            <textarea class="form-control invitation_message" id="message" rows="3" [placeholder]="t('Invitation message field placeholder text (General) - Write your message')" formControlName="message"></textarea>
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <div class="modal-footer">
        <button [disabled]="inviteToReadLoader" type="submit" class="btn btn-primary" rippleEffect>
            {{t("More tab invite to read text (More tab) - Invite to read")}} <span *ngIf="inviteToReadLoader" class="spinner-border spinner-border-sm ms-50"></span>
        </button>
    </div>
    </form>
</div>
<!-- / Invite to read Modal -->
</ng-container>